export enum RentalLeaseType {
    Annual = 0,
    MonthToMonth = 1,
    Vacation = 2,
}
